













import { Component, Vue } from 'vue-property-decorator';

import ArtWork from '@/template/ArtWork.vue';

@Component({
  components: {
    ArtWork,
  },
})
export default class Left extends Vue {

}
